import { render, staticRenderFns } from "./H5App.vue?vue&type=template&id=1cf62f08&scoped=true&"
import script from "./H5App.vue?vue&type=script&lang=ts&"
export * from "./H5App.vue?vue&type=script&lang=ts&"
import style0 from "./H5App.vue?vue&type=style&index=0&id=1cf62f08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf62f08",
  null
  
)

export default component.exports